// Annual Membership Add to Cart function
window.addMembershipToCart = async (btn, event) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: Number(btn.dataset.variantId),
                quantity: Number(btn.dataset.quantity),
                selling_plan: Number(btn.dataset.sellingPlanId)
            }]
        })
    })

    window.location.href = '/cart'
}